import React from "react";
import DialogflowMessenger from "../../components/DialogueFlowMessenger";

export default function Chat() {
  return (
    <div>
      <DialogflowMessenger />
    </div>
  );
}
